<template>
<div>New Group</div>
</template>

<script>
export default {
  name: 'NewReservationGroup',
}
</script>

<style scoped>

</style>
